<template>
  <PageWrapper
    :active-section="SECTION_HOME"
    :active-page="PAGE_HOME"
    align="left"
    width="full"
  >
    <iRow wrap="nowrap">
      <FeedSideBar />
      <SmartFeed
        :pinia-store="useFeedSourceFeedStore"
        default-smart-feed-layout="grid"
        default-entity-layout="cardLarge"
        load-more-behavior="auto"
      />
    </iRow>
  </PageWrapper>
</template>

<script>
import PageWrapper from "@/components/PageWrapper";
import { SECTION_HOME, PAGE_HOME } from "@/constants/nav-constants";
import SmartFeed from "SmartFeed/components/SmartFeed.vue";
import FeedSideBar from "@/components/FeedSideBar.vue";
import { useFeedSourceFeedStore } from "@/smart-feed/stores/feed/feed-source-feed-store";

export default {
  name: "FeedSource",
  components: {
    PageWrapper,
    SmartFeed,
    FeedSideBar,
  },
  data() {
    return {
      SECTION_HOME,
      PAGE_HOME,
    };
  },
  methods: {
    useFeedSourceFeedStore,
  },
};
</script>
